import { useTheme } from '@emotion/react'
import styled from '@emotion/styled'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Footer from '@segment/templates/Footer'
import NavigationV2 from '@segment/templates/Navigation2'
import GettingStarted from '@segment/templates/GettingStarted'

import Layout from '@segment/next-shared/layout'

import Hero from './components/Hero'
import EnsureCustomerData from './components/EnsureCustomerData'
import ManageUserDeletion from './components/ManageUserDeletion'
import BlockDataCollection from './components/BlockDataCollection'
import EnableUserData from './components/EnableUserData'
import SegmentCommitment from './components/SegmentCommitment'
import RelatedContent from './components/RelatedContent'

import ogImagePng from './assets/OgGdpr.png'

const GdprView = () => {
  const theme = useTheme()
  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout
        pageTitle="Automated GDPR Compliance Software | Twilio Segment"
        pageDescription="Twilio Segment helps you simplify GDPR by making it easy to store and process data locally, honor the right to erasure, the right to object, and the right to access, portability, and rectification."
        pageOG={ogImagePng}
        themeColor={theme.palette.neutrals.cloud[100]}
        bodyBackground={theme.palette.neutrals.white[100]}
      >
        <NavigationV2 />
        <Hero />
        <Main>
          <Wrapper>
            <EnsureCustomerData />
            <ManageUserDeletion />
            <BlockDataCollection />
            <EnableUserData />
            <SegmentCommitment />
            <RelatedContent />
          </Wrapper>
          <GettingStarted />
        </Main>
        <Footer />
      </Layout>
    </AppearanceProvider>
  )
}

export default GdprView
const Wrapper = styled.div`
  padding-bottom: 80px;
`
const Main = styled.main``
